module.exports = __webpack_public_path__ + "static/img/aa4.63a6c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104/aa4.png
// module id = L8jN
// module chunks = 0